grecaptcha.ready(function() {
  $('#contact-submit').removeAttr('disabled');
});

$(function(){
  var contactForm = $('#contact-form').parsley();

  //recaptcha
  $('#contact-submit').on('click', function(e){
  	var that = $(this);

  	that.attr('disabled', 'disabled');

  	contactForm.validate();

  	if (contactForm.isValid()) {
    	grecaptcha.execute($('#recaptchaScript').data('sitekey'), {action: 'contact'}).then(function(token) {
    		$('#contact-form [name="g-recaptcha-response"]').val(token);
    		$('#contact-form').submit();
    	});
  	}
  	else {
    	that.removeAttr('disabled');
  	}
  });

  //gmap
  google.maps.event.addDomListener(window, "load", initialize);

	var topMap = null;
	var markersList = [];

	function initialize() {
	  var map;
	  var bounds = new google.maps.LatLngBounds();
	  var pathicon = '/assets/img/frontend/icons/map-pin-small.png';
	  var mapOptions = {
	    mapTypeId: 'roadmap',
	    gestureHandling: 'cooperative',
	    //disableDefaultUI: true,
	    scrollwheel: false
	  };

	  // Display a map on the page
	  map = new google.maps.Map(document.getElementById("map-canvas"), mapOptions);
	  map.setTilt(45);

	  // Multiple Markers
	  var markers = [
	    ['Saint-Hubert, QC', 45.5059324, -73.4400405,1],
	    ['Saint-Hubert, QC', 45.5064302,-73.4396417,2]
	  ];

	  // Info Window Content
	  var infoWindowContent = [
	    ['<div style="text-align: center; padding: 20px 15px 20px 30px; min-width: 240px; max-width: 240px;"><h4>Revêtements Métalliques, R. Lussier Inc. <br/><span class="fw-bold" style="font-size: 0.8em;">(St-Hubert)</span></h4><address><span class="size-medium">2945, Boulevard Losch, St-Hubert (Québec) J3Y 3V6</span></address><a class="size-large fw-bold" href="tel:4509991844">450 999-1844</a><div style="margin: 1em 0 0;"><a href="https://goo.gl/maps/WdCC9SjK4PfTHKQY8" target="_blank" class="btn color-fill colorful">Voir sur la carte</a></div></div>'],
	    ['<div style="text-align: center; padding: 20px 15px 20px 30px; min-width: 240px; max-width: 240px;"><h4>Revêtements Métalliques, R. Lussier Inc. <br/><b>Division toiture</b><br/><span class="fw-bold" style="font-size: 0.8em;">(St-Hubert)</span></h4><address><span class="size-medium">2805, Boulevard Losch, St-Hubert (Québec) J3Y 3V6</span></address><a class="size-large fw-bold" href="tel:4509991844">450 999-1844</a><div style="margin: 1em 0 0;"><a href="https://goo.gl/maps/vx8kwjgnVBcAzjqNA" target="_blank" class="btn color-fill colorful">Voir sur la carte</a></div></div>']
	  ];

	  // Display multiple markers on a map
	  var infoWindow = new google.maps.InfoWindow(), marker, i;

	  // Loop through our array of markers & place each one on the map
	  for( i = 0; i < markers.length; i++ ) {
	    var position = new google.maps.LatLng(markers[i][1], markers[i][2]);
	    bounds.extend(position);
	    marker = new google.maps.Marker({
	      position: position,
	      map: map,
	      icon: pathicon,
	      title: markers[i][0],
	      id: markers[i][3]
	    });

	    // Allow each marker to have an info window
	    google.maps.event.addListener(marker, 'click', (function(marker, i) {
	      return function() {
	        infoWindow.setContent(infoWindowContent[i][0]);
	        infoWindow.open(map, marker);
	      }
	    })(marker, i));

	    markersList.push(marker);

	    // Automatically center the map fitting all markers on the screen
	    map.fitBounds(bounds);
	  }

	  // Override our map zoom level once our fitBounds function runs (Make sure it only runs once)
	  var boundsListener = google.maps.event.addListener((map), 'bounds_changed', function(event) {
	    this.setZoom(15);
	    google.maps.event.removeListener(boundsListener);
	  });
	  var styles = [{"featureType":"landscape.man_made","elementType":"all","stylers":[{"color":"#faf5ed"},{"lightness":"0"},{"gamma":"1"}]},{"featureType":"poi.park","elementType":"geometry.fill","stylers":[{"color":"#bae5a6"}]},{"featureType":"road","elementType":"all","stylers":[{"weight":"1.00"},{"gamma":"1.8"},{"saturation":"0"}]},{"featureType":"road","elementType":"geometry.fill","stylers":[{"hue":"#ffb200"}]},{"featureType":"road.arterial","elementType":"geometry.fill","stylers":[{"lightness":"0"},{"gamma":"1"}]},{"featureType":"transit.station.airport","elementType":"all","stylers":[{"hue":"#b000ff"},{"saturation":"23"},{"lightness":"-4"},{"gamma":"0.80"}]},{"featureType":"water","elementType":"all","stylers":[{"color":"#a0daf2"}]}];
	  map.setOptions({styles: styles});
	  topMap = map;
	}
});